// import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerClienteSecundario(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/cliente-secundario/list-cliente-secundario",
            API_BASE_URL + "/cliente-secundario/list-cliente-secundario",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("obtenerClienteSecundario err");
        console.log(err);
        return [];
    }
}

export async function createClienteSecundario(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/cliente-secundario/create-cliente-secundario",
            API_BASE_URL + "/cliente-secundario/create-cliente-secundario",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createInstalacion err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deleteClienteSecundario(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/cliente-secundario/delete-cliente-secundario",
            API_BASE_URL + "/cliente-secundario/delete-cliente-secundario",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deleteClienteSecundario err");
        console.log(err);
        return { error: true, message: err };
    }
}